module.exports = __webpack_public_path__ + "dc4af3b1c665085346a9155880e8c0bd.svg";